/* ═══════════════════════════════════════════════════════════
   YOURS TRULY — Supabase Client
   ═══════════════════════════════════════════════════════════ */

import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://blkaqngwcfbrzpgnubai.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJsa2Fxbmd3Y2ZicnpwZ251YmFpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODMwOTc1MjcsImV4cCI6MjA5ODY3MzUyN30.Mf7k11wexggAkWTpb8G4H1S7skk60E1R6mwFWbWp9jI";

// Export for modules that need the raw client (e.g. storage uploads)
export var supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

const headers = {
  apikey: SUPABASE_ANON_KEY,
  Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
  "Content-Type": "application/json",
  Prefer: "return=representation",
};

export async function createSession(vertical = "corporate") {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/sessions`, {
    method: "POST",
    headers,
    body: JSON.stringify({ vertical, status: "in_progress" }),
  });
  const data = await res.json();
  return data[0];
}

export async function updateSession(id, updates) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/sessions?id=eq.${id}`, {
    method: "PATCH",
    headers,
    body: JSON.stringify(updates),
  });
  return res.ok;
}

export async function getSessions(filters = {}) {
  let url = `${SUPABASE_URL}/rest/v1/sessions?order=created_at.desc`;
  if (filters.vertical) url += `&vertical=eq.${filters.vertical}`;
  if (filters.status) url += `&status=eq.${filters.status}`;
  const res = await fetch(url, { headers });
  return res.json();
}

export async function getSession(id) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/sessions?id=eq.${id}`, { headers });
  const data = await res.json();
  return data[0];
}

/* ── Constellation functions ── */

export async function createConstellation({ recipient_name, occasion, creator_name, creator_email, company, vertical }) {
  const slug = Math.random().toString(36).substring(2, 8);
  const res = await fetch(`${SUPABASE_URL}/rest/v1/constellations`, {
    method: "POST",
    headers,
    body: JSON.stringify({ slug, recipient_name, occasion, creator_name, creator_email, company, vertical, status: "collecting" }),
  });
  const data = await res.json();
  return data[0];
}

export async function getConstellation(slug) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/constellations?slug=eq.${slug}`, { headers });
  const data = await res.json();
  return data[0];
}

export async function addContribution(constellation_id, { contributor_name, relationship, elements, transcript, star_label, email }) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/contributions`, {
    method: "POST",
    headers,
    body: JSON.stringify({ constellation_id, contributor_name, relationship, elements, transcript, star_label, email }),
  });
  const data = await res.json();
  return data[0];
}

export async function saveDesigns(constellation_id, designs) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/constellations?id=eq.${constellation_id}`, {
    method: "PATCH",
    headers,
    body: JSON.stringify({ designs }),
  });
  return res.ok;
}

export async function getContributions(constellation_id) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/contributions?constellation_id=eq.${constellation_id}&order=created_at.asc`, { headers });
  return res.json();
}

export async function getConstellations() {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/constellations?order=created_at.desc`, { headers });
  return res.json();
}
